import { GetConnectivityQueryArg } from '../types/query-arg';
import { GetConnectivityQueryParams } from '../types/query-params';

export const getConnectivityQueryParams = (
  queryArg: GetConnectivityQueryArg,
): GetConnectivityQueryParams => ({
  unitId: queryArg.unitId,
  page: queryArg.page ?? 1,
  limit: queryArg.limit ?? 50,
});
